module.exports = __webpack_public_path__ + "img/coupon-detail-pocket.d4ae34bf.png";